<h2 mat-dialog-title>{{ data.title ?? 'Input' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="submit()" >
    <mat-form-field appearance="outline" class="mt-10 full-width">
      <mat-label>{{ data.label ?? 'Value' }}</mat-label>

      <input
        matInput
        formControlName="value"
        cdkFocusInitial
        autocomplete="off"
        [placeholder]="data.placeholder ?? ''"
      />

      @if (form.get('value')?.hasError('required') && form.get('value')?.touched) {
        <mat-error>{{ data.label ?? 'Value' }} is required</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button type="button" (click)="submit()">
    {{ data.buttonLabel ?? 'Save' }}
  </button>

  <button mat-button type="button" (click)="close()">
    Cancel
  </button>
</mat-dialog-actions>